var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "favorites px-0" },
    [
      _c("div", { staticClass: "bg-white w-100 p-2" }),
      _vm.savedAdverts !== undefined && _vm.savedAdverts.length > 0
        ? _c("JobViewContainer", {
            staticClass: "mt-4",
            attrs: {
              jobPostings: _vm.savedAdverts,
              isSearching: false,
              useSavedAdvert: true,
              selectedJobPosting: _vm.selectedJobPosting,
              activeIndex: _vm.activeIndex,
            },
            on: {
              setActiveIndex: function ($event) {
                return _vm.setActiveIndex($event)
              },
              setSelectedJobPosting: function ($event) {
                return _vm.setSelectedJobPosting($event)
              },
            },
          })
        : _c(
            "div",
            { staticClass: "no-advert flex-column d-flex align-items-center" },
            [
              _c("div", { staticClass: "brand bottom-border mb-5" }, [
                !_vm.isMobile
                  ? _c("h2", { staticClass: "font-weight-bold pb-3" }, [
                      _vm._v(_vm._s(_vm.content.noFavorites)),
                    ])
                  : _c("h4", { staticClass: "font-weight-bold pb-3" }, [
                      _vm._v(_vm._s(_vm.content.noFavorites)),
                    ]),
              ]),
            ]
          ),
      _vm.selectedJobPosting !== undefined
        ? _c("MobileButtonBottom", {
            attrs: {
              selectedJobPosting: _vm.selectedJobPosting,
              mobileFilterIsActive: false,
              content: undefined,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }